/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Hub_No_TriggersInputs */



/**
* | output |
* | --- |
* | "It does not run on its own yet." |
*
* @param {Agent_Hub_No_TriggersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_hub_no_triggers = /** @type {((inputs?: Agent_Hub_No_TriggersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Hub_No_TriggersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Auslöser.")
	return /** @type {LocalizedString} */ ("It does not run on its own yet.")
});